import { useState, useCallback } from 'react';
import { StaticValues } from '../../../../../insfrastructure/services/static_values';
import { SegmentOption } from '../types';
import { formatDateForAPI, removeFormatting } from '../utils/formatters';
import moment from 'moment';

export const useFieldEditing = (
  segmentOptions: SegmentOption[],
  genderOptions: { [key: string]: string }
) => {
  const [editingField, setEditingField] = useState<string | null>(null);
  const [editingValue, setEditingValue] = useState<any>('');

  const startEditing = useCallback((field: string, currentValue: any): void => {
    let value: any = currentValue;
    
    // Aplicar máscaras para campos que precisam de formatação visual
    if (field === 'date_of_birth' && currentValue) {
      try {
        // Converte para formato DD/MM/YYYY para o DateOfBirthField (InputMask)
        const date = moment(currentValue);
        if (date.isValid()) {
          value = date.format('DD/MM/YYYY');
        } else {
          value = currentValue;
        }
      } catch (error) {
        console.error('Erro ao converter data:', error);
        value = currentValue;
      }
    } else if (field === 'gender' && currentValue) {
      const staticValues = JSON.parse(localStorage.getItem('static_values') || '{}') as StaticValues;
      if (staticValues.gender) {
        if (staticValues.gender[currentValue]) {
          value = currentValue;
        } else {
          const foundKey = Object.keys(staticValues.gender).find(key => 
            staticValues.gender[key] === currentValue || 
            staticValues.gender[key].toLowerCase() === String(currentValue).toLowerCase()
          );
          value = foundKey || currentValue;
        }
      } else {
        value = currentValue;
      }
    } else if (field === 'company_segment' && currentValue) {
      let segmentOption = null;
      
      // Tentar encontrar pelo segment_id
      if (segmentOptions.length > 0) {
        segmentOption = segmentOptions.find(opt => 
          String(opt.value) === String(currentValue) || opt.label === currentValue
        );
      }
      
      if (segmentOption) {
        value = segmentOption.value;
      } else {
        value = '';
      }
    }
    
    setEditingField(field);
    setEditingValue(value);
  }, [segmentOptions]);

  const cancelEditing = useCallback((): void => {
    setEditingField(null);
    setEditingValue('');
  }, []);

  const formatValueForAPI = useCallback((field: string, value: any): any => {
    if (field === 'date_of_birth' && value) {
      return formatDateForAPI(value);
    } else if (field === 'cpf' && value) {
      return removeFormatting(String(value));
    } else if (field === 'company_cnpj' && value) {
      return removeFormatting(String(value));
    } else if ((field === 'phone' || field === 'company_phone') && value) {
      return removeFormatting(String(value));
    } else if (field === 'company_segment' && value) {
      return value;
    }
    return String(value || '').trim();
  }, []);

  return {
    editingField,
    editingValue,
    setEditingValue,
    startEditing,
    cancelEditing,
    formatValueForAPI
  };
};

